import React, { PropsWithChildren } from 'react'
import { Navigate, useLocation } from 'react-router'
import { useAuth } from './AuthProvider'

const PrivateRoute: React.FunctionComponent<PropsWithChildren> = ({
  children,
}) => {
  const { isLoggedIn, isInitialized, countryInformation } = useAuth()
  const location = useLocation()

  const hasCountryInfo =
    !!countryInformation.countryOfCitizenship &&
    !!countryInformation.countryOfResidence

  /* AuthProvider already renders LoginSkeleton until isInitialized is true.
     Returning null here prevents the synchronous Navigate to /login redirect
     that would otherwise fire before the session check completes and flash the
     login form skeleton on every account route reload.
     Skipped in tests so suites that dont pass testConfig
     still exercise the logged in / logged out branching. */
  if (!isInitialized && process.env.NODE_ENV !== 'test') {
    return null
  }

  if (!isLoggedIn)
    return (
      <Navigate
        to={{
          pathname: '/login',
        }}
        state={{ from: location.pathname }}
        replace
      />
    )

  return hasCountryInfo ? (
    <>{children}</>
  ) : (
    <Navigate
      to={{
        pathname: '/country-information',
      }}
      state={{ from: location.pathname }}
      replace
    />
  )
}

export default PrivateRoute
